export { default } from "./useGuidedHighlightingStudent";

export * from "./useGuidedHighlightingStudent";
